import { gettext } from '@eb/i18n';
import { css, cx } from 'emotion';
import React from 'react';
import { CollectionCards } from '../_shared/CollectionCards';
import { LoadMoreCollections } from '../_shared/LoadMoreCollections';
import { useEventCollections } from '../_shared/useEventCollections';

export const COLLECTIONS_PAGE_SIZE = 3;
export const LAYOUT_COLUMNS = 1;

export interface Props {
    eventId: string;
}

export const MoreRelatedCollections: React.FC<Props> = ({ eventId }) => {
    const {
        collections,
        loadNextPage,
        count,
        hasMoreCollections,
        areCollectionsLoading,
    } = useEventCollections(eventId, COLLECTIONS_PAGE_SIZE);

    if (count === 0) {
        return <></>;
    }

    return (
        <div>
            <hr className="l-section eds-l-mar-top-2" />
            <div
                className={
                    'eds-text--center eds-text-hs eds-l-mar-bot-12 eds-l-mar-top-12 l-align-center'
                }
            >
                <span className="">
                    {gettext('More collections that feature this event')}
                </span>
            </div>
            <div className={cx(styles.cardsContainer)}>
                <CollectionCards
                    collections={collections}
                    columns={LAYOUT_COLUMNS}
                />
                <div className="eds-l-mar-top-6">
                    <LoadMoreCollections
                        areCollectionsLoading={areCollectionsLoading}
                        loadNextPage={loadNextPage}
                        hasMoreCollections={hasMoreCollections}
                    />
                </div>
            </div>
        </div>
    );
};

const styles = {
    cardsContainer: css`
        max-width: 660px;
        margin: auto;
        font-size: 16px;
    `,
};
